import React from 'react';
import { isMobile } from 'react-device-detect';
import { useFilters } from './useFilters';

export const TableFilters = () => {
  const { filters, clearFilter } = useFilters();

  if (!filters.length) return null;

  if (isMobile) return null;

  return (
    <div className="action-groups-beneficiaries-filter">
      {filters.map((filter) => (
        <div key={filter.label} className="filter">
          {filter.label}
          <button type="button" data-testid="button-clear-filter" onClick={() => clearFilter(filter)}>
            <i className="material-icons">close</i>
          </button>
        </div>
      ))}
    </div>
  );
};
